import { columns, rows } from './tableData';
import { SortableTable } from '../SortableTable';

import type { FC } from 'react';

export const SupportedMarketsTable: FC = () => (
  <SortableTable columns={columns} rows={rows} defaultSortColumn="market-country" />
);
